import { render, staticRenderFns } from "./cSimpleDocParts.vue?vue&type=template&id=0d35ddc4&scoped=true"
import script from "./cSimpleDocParts.vue?vue&type=script&lang=js"
export * from "./cSimpleDocParts.vue?vue&type=script&lang=js"
import style0 from "./cSimpleDocParts.vue?vue&type=style&index=0&id=0d35ddc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35ddc4",
  null
  
)

export default component.exports